import type { AppSession, PermissionKey } from './auth'

export function hasPermission(session: AppSession, permission: PermissionKey): boolean {
  return session.permissions.includes(permission)
}

export function hasAnyPermission(session: AppSession, permissions: readonly PermissionKey[]): boolean {
  return permissions.some((permission) => hasPermission(session, permission))
}

export function authorize(session: AppSession, permission: PermissionKey): void {
  if (!hasPermission(session, permission)) {
    throw new Error(`FORBIDDEN:${permission}`)
  }
}

/**
 * Destination après connexion : un compte terrain (balises) n'a ni tableau de bord ni autre module,
 * il arrive directement sur son interface plutôt que sur une page « accès refusé ».
 */
export const passwordChangePath = '/compte/mot-de-passe'

export function homePathFor(session: AppSession | null, fallback: string): string {
  if (session?.status === 'PASSWORD_CHANGE_REQUIRED') return passwordChangePath
  if (session && !hasPermission(session, 'dashboard.read') && hasPermission(session, 'marker.read'))
    return '/balises/terrain'
  return fallback
}

/**
 * Destination après connexion. Une page visitée avant la connexion est respectée, sauf pour un compte
 * terrain : lui renvoyer `/vue-ensemble` (ou toute page du bureau) afficherait « accès refusé ».
 */
export function loginDestination(
  session: AppSession | null,
  requested: string | null,
  fallback: string,
): string {
  const home = homePathFor(session, fallback)
  if (home === passwordChangePath) return home
  const safe = requested?.startsWith('/') && !requested.startsWith('//') ? requested : null
  if (!safe) return home
  if (home === '/balises/terrain' && !safe.startsWith('/balises')) return home
  return safe
}
